/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from 'utils/styles/style_helpers';
import { url } from 'utils/urls';


/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// QUESTION FORMAT : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	questionformat: {
		cursor: 'pointer',
		display: 'block',
		marginTop: pxToEm(15),
		'&:hover': {
			'& .desc': {
				'& .text': {
					color: theme.color.primary.medium.swatch
				}
			}
		},
		'&:nth-child(1)': { marginTop: '0' },
		'&:nth-child(2)': { marginTop: '0' },
		'& .visual': {
			backgroundColor: 'transparent',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: '50%',
			backgroundSize: 'contain',
			width: pxToEm(80),
			height: pxToEm(80),
			marginBottom: pxToEm(10)
		},
		'& .desc': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			'& .icon': {
				backgroundColor: 'transparent',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: '50%',
				backgroundSize: 'contain',
				width: pxToEm(20),
				height: pxToEm(25),
				marginRight: pxToEm(5)
			},
			'& .text': {
				transition: 'all .2s linear 0s',
				extend: theme.typography.size.small
			}
		},
		'&.active': {
			'& .text': {
				color: theme.color.primary.medium.swatch
			}
		},
		'&.emoji': {
			'& .visual': { backgroundImage: `url(${url.image.app}/embed-layout-emoji-pic-inactive.png)` },
			'& .icon': { backgroundImage: `url(${url.image.app}/embed-layout-emoji-icon-default.png)` },
			'&.active': {
				'& .visual': { backgroundImage: `url(${url.image.app}/embed-layout-emoji-pic-active.png)` },
				'& .icon': { backgroundImage: `url(${url.image.app}/embed-layout-emoji-icon-default.png)` }
			}
		},
		'&.image1': {
			'& .visual': { backgroundImage: `url(${url.image.app}/embed-layout-round-pic-inactive.png)` },
			'& .icon': { backgroundImage: `url(${url.image.app}/embed-layout-round-icon-default.png)` },
			'&.active': {
				'& .visual': { backgroundImage: `url(${url.image.app}/embed-layout-round-pic-active.png)` },
				'& .icon': { backgroundImage: `url(${url.image.app}/embed-layout-round-icon-active.png)` }
			}
		},
		'&.image2': {
			'& .visual': { backgroundImage: `url(${url.image.app}/embed-layout-large-pic-inactive.png)` },
			'& .icon': { backgroundImage: `url(${url.image.app}/embed-layout-large-icon-default.png)` },
			'&.active': {
				'& .visual': { backgroundImage: `url(${url.image.app}/embed-layout-large-pic-active.png)` },
				'& .icon': { backgroundImage: `url(${url.image.app}/embed-layout-large-icon-active.png)` }
			}
		},
        '&.text1': {
            '& .visual': { backgroundImage: `url(${url.image.app}/embed-layout-text-poll-pic-inactive.png)` },
			'& .icon': { backgroundImage: `url(${url.image.app}/embed-layout-text-icon-default.png)` },
			'&.active': {
				'& .visual': { backgroundImage: `url(${url.image.app}/embed-layout-text-poll-pic-active.png)` },
				'& .icon': { backgroundImage: `url(${url.image.app}/embed-layout-text-icon-active.png)` }
			}
        },
        '&.text2': {
			'& .visual': { backgroundImage: `url(${url.image.app}/embed-layout-text-full-pic-inactive.png)` },
			'& .icon': { backgroundImage: `url(${url.image.app}/embed-layout-text-icon-default.png)` },
			'&.active': {
				'& .visual': { backgroundImage: `url(${url.image.app}/embed-layout-text-full-pic-active.png)` },
				'& .icon': { backgroundImage: `url(${url.image.app}/embed-layout-text-icon-active.png)` }
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //

	[mediaQuery.customizeThinnest]: {
		questionformat: {
			margin: 0
		}
	},
});